module.exports = __webpack_public_path__ + "static/media/arrow-right-icon.f73207f6.svg";